import React, { useEffect, useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { useNavigate } from "react-router-dom";
import { Helper } from "../../../tools/Helper";
import { api_Routes } from "../../../tools/api_Routes";
import { useDispatch } from "react-redux";
import { setSuccess } from "../../../Redux/AlertReducer";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

const DataTable = ({ data }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [selectedItem, setSelectedItem] = useState(null);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);

  const handleStatusChange = async () => {
    setIsProcessing(true);
    const newStatus = selectedItem?.status === "closed" ? "answered" : "closed";
    const url = `${api_Routes.Support.UpdateStatus}/${selectedItem?.id}`;

    const { response } = await Helper.Post({
      url,
      hasToken: true,
    });

    if (response) {
      dispatch(setSuccess(true));
      window.location.reload(); // Refresh the page
    }

    setIsProcessing(false);
    setShowConfirmation(false);
  };

  return (
    <>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow className="bg-primary">
              <TableCell
                align="center"
                className="!text-darkTextColor whitespace-nowrap"
              >
                ID
              </TableCell>
              <TableCell
                align="center"
                className="!text-darkTextColor whitespace-nowrap"
              >
                Title
              </TableCell>
              <TableCell
                align="center"
                className="!text-darkTextColor whitespace-nowrap"
              >
                Status
              </TableCell>
              <TableCell
                align="center"
                className="!text-darkTextColor whitespace-nowrap"
              >
                Category
              </TableCell>
              <TableCell
                align="center"
                className="!text-darkTextColor whitespace-nowrap"
              >
                User
              </TableCell>
              <TableCell
                align="center"
                className="!text-darkTextColor whitespace-nowrap"
              >
                Updated at
              </TableCell>
              <TableCell
                align="center"
                className="!text-darkTextColor whitespace-nowrap"
              >
                Chat
              </TableCell>
              <TableCell
                align="center"
                className="!text-darkTextColor whitespace-nowrap"
              >
                Action
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((item) => (
              <TableRow
                key={item.id}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell component="th" scope="row" align="center">
                  {item?.id}
                </TableCell>
                <TableCell align="center">{item?.title}</TableCell>
                <TableCell align="center">
                  <span
                    className={`badge w-24 text-darkTextColor ${
                      item?.status === "answered"
                        ? "bg-[#28a745]"
                        : item?.status === "pending"
                        ? "bg-[#f7cb73]"
                        : "bg-[#ff6877]"
                    }`}
                  >
                    {item?.status}
                  </span>
                </TableCell>
                <TableCell align="center">{item?.category}</TableCell>
                <TableCell align="center">{item?.user_name}</TableCell>
                <TableCell align="center">{item?.updated_at}</TableCell>
                <TableCell align="center">
                  {" "}
                  <div className="flex items-center justify-center w-full">
                    <button
                      type="button"
                      onClick={() => {
                        // setSelectedItem(item);
                        // handleShow();
                        navigate(`/Support/${item?.id}`);
                      }}
                      className="bg-primary m-1 py-2 px-8 font-medium text-[1.0625em] rounded-[0.25em] text-darkTextColor flex justify-center"
                    >
                      Chat
                    </button>
                  </div>
                </TableCell>

                <TableCell align="center">
                  <div className="flex items-center justify-center w-full">
                    <Button
                      type="button"
                      disabled={isProcessing}
                      onClick={() => {
                        setSelectedItem(item);
                        setShowConfirmation(true);
                      }}
                      sx={{
                        color: item?.status === "closed" ? "green" : "darkred",
                        ":hover": {
                          bgcolor:
                            item?.status === "closed" ? "#28a745" : "red",
                        },
                      }}
                    >
                      {item?.status === "closed" ? "Reopen" : "Close"}
                    </Button>
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Confirmation Dialog */}
      <Dialog
        open={showConfirmation}
        onClose={() => setShowConfirmation(false)}
      >
        <DialogTitle>
          Confirm {selectedItem?.status === "closed" ? "Reopen" : "Close"}{" "}
          Ticket
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {`Are you sure you want to ${
              selectedItem?.status === "closed" ? "reopen" : "close"
            } this ticket?`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowConfirmation(false)}>Cancel</Button>
          <Button
            onClick={handleStatusChange}
            color="primary"
            disabled={isProcessing}
          >
            {isProcessing ? "Processing..." : "Confirm"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DataTable;
